<!-- Step 3 body — Payment (handoff §Step 3). Saved-card option rows with
     typographic brand chips; expired cards are dimmed and non-selectable. -->

<p class="pay-lead">Select your payment method.</p>

<div class="pay-rows" role="radiogroup" aria-label="Payment method">
    <vb-option-row
        *ngFor="let card of paymentMethods"
        [label]="card.cardNumber"
        [description]="'Exp ' + (card.expirationDate | expiryFormat)"
        [selected]="selectedPaymentCard === card"
        [disabled]="isExpired(card)"
        [tag]="cardTag(card)"
        [tagTone]="isExpired(card) ? 'red' : 'amber'"
        (clicked)="selectCard(card)">
        <span
            vbOptionLeading
            class="pay-brand"
            [class.pay-brand--generic]="!brandChip(card)"
            [style.background]="brandChip(card)?.color || null">
            {{ brandChip(card)?.label || 'CARD' }}
        </span>
    </vb-option-row>

    <p class="pay-empty" *ngIf="paymentMethods.length === 0">
        No saved cards found.
    </p>

    <vb-option-row
        *ngIf="showPayOnPickup"
        label="Pay on pickup"
        description="Pay in person by card when you collect."
        [selected]="isPayOnPickup"
        (clicked)="selectPayOnPickup()">
    </vb-option-row>
</div>

<button type="button" class="pay-addlink" (click)="goToAddCard()">
    + Add new payment method
</button>

<div class="pay-actions">
    <vb-button
        variant="primary"
        [disabled]="!selectedPaymentCard && !isPayOnPickup"
        (clicked)="onPaymentNextClick()">
        Next
    </vb-button>
</div>
